import { makeRequestAction } from './index';

export const getDeal = makeRequestAction('GET_GUEST_DEAL', {
  onSuccess(params, response) {
    return {
      response: {
        ...response,
      },
    };
  },
});
